export default __webpack_public_path__ + "assets/8a5170faac2f3443dbe3ea3eadaeb4e0.png";